import { useContext } from 'react';

import { AuthContext, type AuthContextValue } from './AuthContext';

/**
 * Throws outside the provider rather than returning a null session, which
 * would render every screen as "signed out" and look like a bug in the guard.
 */
export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);

  if (context === null) {
    throw new Error('useAuth must be used inside <AuthProvider>.');
  }

  return context;
}
